import { Observable } from 'rxjs';
import { StateObservable, ofType } from 'redux-observable';
import { map, filter, withLatestFrom } from 'rxjs/operators';
import { StartRelease } from '@webapp/store/release/action-creators';
import { START_RELEASE } from '@webapp/store/release/actions';
import { rudderTrack } from '@webapp/utils/rudderstack/init';
import AppState from '@webapp/store/state';

export const trackReleaseStarted = (
  action$: Observable<StartRelease>,
  state$: StateObservable<AppState>
) =>
  action$.pipe(
    ofType(START_RELEASE),
    withLatestFrom(state$),
    map(([_, state]) => {
      if (window.analytics) {
        window.analytics.track('Release Started', {});
      }
      rudderTrack('Release Initiated', {
        artist_id: state.artist.active?.id,
        artistName: state.artist.active?.name,
      });
    }),
    filter(() => false)
  );
